import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "15",
  height: "13",
  fill: "none",
  viewBox: "0 0 15 13"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      stroke: "#696986",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      d: "M4.167 5.833H2.233c-.373 0-.56 0-.702.073a.67.67 0 0 0-.292.291c-.072.143-.072.33-.072.703v5.6m9-6.667H12.1c.373 0 .56 0 .703.073a.67.67 0 0 1 .291.291c.073.143.073.33.073.703v5.6m-3 0V2.633c0-.746 0-1.12-.146-1.405A1.33 1.33 0 0 0 9.44.645C9.153.5 8.78.5 8.033.5H6.3c-.747 0-1.12 0-1.405.145-.251.128-.455.332-.583.583-.145.285-.145.659-.145 1.405V12.5m9.666 0H.5m6-9.333h1.333M6.5 5.833h1.333M6.5 8.5h1.333"
    }, null, -1)
  ]))]))
}
export default { render: render }